import * as moment from 'moment';
import { TripPingStatus } from './trip-ping-status';

export class FirebaseTripPing {

  public id: string;
  public loadId: string;
  public createdAt: moment.Moment;
  public deviceId: string;
  public vehicle: string;

  public latitude: number;
  public longitude: number;

  public accuracy: number;
  public altitude: number;
  public moving: boolean;

  public statuses: TripPingStatus[] = [];

  static fromDto(p): FirebaseTripPing {
    if (!p) {
      return null;
    }

    const ping     = new FirebaseTripPing();
    ping.id        = p.id;
    ping.loadId    = p.loadId;
    ping.deviceId  = p.deviceId;
    ping.vehicle   = p.vehicle;
    ping.latitude  = p.latitude;
    ping.longitude = p.longitude;

    ping.accuracy  = p.accuracy;
    ping.altitude  = p.altitude;
    ping.moving    = p.moving;
    ping.createdAt = p.createdAt ? moment(p.createdAt) : null;

    ping.statuses = p.statuses || [];

    return ping;
  }
}
